import type { Messages } from "@shared/i18n-react-intl";

import { type SupportedLocale } from "./types";

const getKyKG = () => {
  return import("./translations/ky-KG.json").then((res) => res.default);
};

const getRuRu = () => {
  return import("./translations/ru-RU.json").then((res) => res.default);
};

const getEnUS = () => {
  return import("./translations/en-US.json").then((res) => res.default);
};

const messagesLoaders: Record<SupportedLocale, () => Promise<Messages>> = {
  "en-US": getEnUS,
  "ky-KG": getKyKG,
  "ru-RU": getRuRu,
};

export const getMessagesByLocale = async (
  locale: SupportedLocale,
  defaultLocale: SupportedLocale,
) => {
  const loader = await messagesLoaders[locale || defaultLocale]();

  return loader;
};
